import React from 'react'
import PropTypes from 'prop-types'
import { Form, Typography } from 'antd'
import dayjs from 'dayjs'
import { DatePickerF, SelectF } from '@/i2antdV5'
import { formatDayString, parseHmStringToDayMinutes } from '@/utils/renderUtils'

const FormItem = Form.Item
const { Text } = Typography

function startClock (raw) {
  const minutes = parseHmStringToDayMinutes(raw)
  if (minutes == null) return undefined
  const hh = Math.floor(minutes / 60)
  const mm = minutes % 60
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
}

class DispatchForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    appointment: PropTypes.object,
    startOptions: PropTypes.array,
    date: PropTypes.string,
    idleTechnicianOptions: PropTypes.func
  }

  componentDidMount () {
    this.syncRecord()
  }

  componentDidUpdate (prevProps) {
    const prevId = prevProps.appointment && prevProps.appointment.id
    const nextId = this.props.appointment && this.props.appointment.id
    const prevStart = prevProps.appointment && prevProps.appointment.startTime
    const nextStart = this.props.appointment && this.props.appointment.startTime
    const prevDate = (prevProps.appointment && prevProps.appointment.appointmentDate) || prevProps.date
    const nextDate = (this.props.appointment && this.props.appointment.appointmentDate) || this.props.date
    if (prevId === nextId && prevStart === nextStart && prevDate === nextDate) return
    this.syncRecord()
  }

  syncRecord = () => {
    const { form, appointment, date } = this.props
    if (!form || !form.current) return
    const values = {
      technicianId: undefined,
      date,
      start: undefined
    }
    if (appointment) {
      values.date = formatDayString(appointment.appointmentDate) || date
      values.start = startClock(appointment.startTime)
    }
    form.current.setFieldsValue(values)
    this.forceUpdate()
  }

  idleOptions = (date, start) => {
    const { appointment, idleTechnicianOptions } = this.props
    if (!date || !start) return []
    const duration = Number(appointment && appointment.durationMinutes) || 60
    const ignoreId = appointment ? appointment.id : null
    return idleTechnicianOptions(date, start, ignoreId, duration)
  }

  handleValuesChange = (changed) => {
    if (changed.date === undefined && changed.start === undefined) return
    const { form } = this.props
    if (!form || !form.current) return
    const technicianId = form.current.getFieldValue('technicianId')
    if (!technicianId) return
    const date = form.current.getFieldValue('date')
    const start = form.current.getFieldValue('start')
    const options = this.idleOptions(date, start)
    if (options.some((row) => row.id === technicianId)) return
    form.current.setFieldsValue({ technicianId: undefined })
  }

  render () {
    const { form, appointment, startOptions } = this.props
    return (
      <Form ref={form} layout="vertical" onValuesChange={this.handleValuesChange}>
        <FormItem
          label="日期"
          name="date"
          rules={[{ required: true, message: '请选择日期' }]}
        >
          <DatePickerF
            dateStrValue
            modalProps={{
              size: 'large',
              allowClear: false,
              format: 'YYYY-MM-DD',
              style: { width: '100%' },
              getPopupContainer: () => document.body,
              disabledDate: (current) => current && current.isBefore(dayjs(), 'day')
            }}
          />
        </FormItem>
        <FormItem
          label="时间"
          name="start"
          rules={[{ required: true, message: '请选择时间' }]}
        >
          <SelectF modalProps={{ size: 'large' }} options={startOptions || []} />
        </FormItem>
        <FormItem noStyle shouldUpdate={(prev, cur) => prev.date !== cur.date || prev.start !== cur.start}>
          {() => {
            const date = form && form.current ? form.current.getFieldValue('date') : undefined
            const start = form && form.current ? form.current.getFieldValue('start') : undefined
            const ready = !!(date && start)
            const options = this.idleOptions(date, start)
            let placeholder = '请先选日期和时间'
            if (ready && options.length) placeholder = '请选择空闲师傅'
            if (ready && !options.length) placeholder = '这个时间没有空闲师傅'
            return (
              <FormItem
                label="师傅"
                name="technicianId"
                rules={[{ required: true, message: '请选择师傅' }]}
              >
                <SelectF
                  options={options}
                  modalProps={{
                    size: 'large',
                    disabled: !ready,
                    placeholder,
                    notFoundContent: '这个时间没有空闲师傅'
                  }}
                />
              </FormItem>
            )
          }}
        </FormItem>
        <Text type="secondary">
          {appointment ? `${appointment.projectName || appointment.reservationNo}` : ''}
          {' '}
          先选日期和时间，只显示这段空闲的师傅。派人后仍是还没开始。
        </Text>
      </Form>
    )
  }
}

export default DispatchForm
